<hr class="mb-3" />
<div
  data-test-id="div-notification"
  (click)="handleRoute(data)"
  [ngClass]="{ navigatable: data && data.routerUrl }"
  ngbDropdownItem
>
  <p class="d-inline-block mb-2 w-100" *ngIf="data" data-test-id="message">
    <span
      *ngFor="let chunk of data.message; index as i"
      [attr.data-test-id]="'chunk-' + i"
      [class.text-primary]="chunk.href"
      [attr.role]="chunk.href ? 'button' : ''"
      [class]="chunk.href ? 'btn-link text-break' : ''"
      (click)="chunk.href ? $event.stopPropagation() || navigate(chunk) : null"
    >
      {{ chunk.text }}
    </span>
  </p>
  <div class="d-flex align-items-center justify-content-between">
    <time data-test-id="date-created" class="text-truncate small" [dateTime]="data?.dateCreated">{{
      data?.dateCreated | date: DATE_TIME_FORMAT_SHORT
    }}</time>
    <div>
      <button data-test-id="confirm-button" class="btn btn-sm btn-primary" (click)="onActionExecuted('confirmAction')">
        Accept
      </button>
      <button
        data-test-id="reject-button"
        class="btn btn-sm btn-secondary ms-2"
        (click)="onActionExecuted('rejectAction')"
      >
        Decline
      </button>
    </div>
  </div>
</div>
